/**
 * DS `Select` の「閉じた状態」の文字を design 準拠の 14px (md) に固定する css。
 *
 * ## なぜ要るか
 *
 * `chakra-react-select` は control 系スロットの寸法・font を
 * `useSlotRecipe({ key: 'select' })({ size })` から取る。ecloud は
 * `select` レシピを持たない (theme/components に select.recipe.ts が無い) ため
 * **Chakra v3 の既定 select レシピ**にフォールバックし、その `md` は
 * `textStyle: 'sm'` = ecloud の `fontSizes.sm` = **12px** に解決される
 * (`size` を md にしても 14px にならない。lg にすると 14px だが高さが
 * design の 40px から外れる)。
 *
 * DS Select 側は `chakraStyles.control` / `.singleValue` に `textStyle: 'textMd'`
 * を持つが、実機では 12px のまま出ている (2026-08-03 デザイナー目視)。
 * design `.ecl-select` は **height 40px / font-size md(14px)** が正なので、
 * 呼び出し側で明示的に 14px を上書きする。
 *
 * ## なぜ `chakraStyles` で書かないか
 *
 * 呼び出し側が `chakraStyles` を渡すと **DS 側の chakraStyles を丸ごと置き換える**
 * (DS Select は chakraStyles を先に置き `{...rest}` が後勝ち)。選択時背景・
 * list の font-size・▽ 左の区切り線などが同時に失われる。
 *
 * ## 適用範囲
 *
 * Select を包む `Box` に `css={selectFontFix}` として当てる。menu は
 * `menuPortalTarget={document.body}` で body 直下に出るため**この Box の外**にあり、
 * DS の menuList / option (14px) はそのまま効く。
 */
export const selectFontFix = {
  '& *': { fontSize: '14px' },
} as const
